import React from 'react'
import '../../css/procesoEmbarque.scss'
import tiempo from '../../assets/images/recomendacion/embarque/atras-en-el-tiempo.png'
import embarque from '../../assets/images/recomendacion/embarque/tarjeta-de-embarque.png'
import control from '../../assets/images/recomendacion/embarque/control-de-pasaportes.png'
import autobus from '../../assets/images/recomendacion/embarque/autobus-escolar.png'
export default function EmbarqueAuto() {
  return (
    <>
        <section className='proceso-embarque'>
            <div className='container'>
                <div className='proceso-embarque-content'>
                    <div className='proceso-embarque-box'>
                        <div className='proceso-embarque-box-in'>
                            1
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <img src={tiempo} alt='' />
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <h2>Llega al puerto con 2 h de antelación.</h2>
                            <p>Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles.</p>
                        </div>
                    </div>
                    <div className='proceso-embarque-box'>
                        <div className='proceso-embarque-box-in'>
                            2
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <img src={embarque} alt='' />
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <h2>Mantén tu pase de abordar a la mano. </h2>
                            <p>En QR o impreso. Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles.</p>
                        </div>
                    </div>
                    <div className='proceso-embarque-box'>
                        <div className='proceso-embarque-box-in'>
                            3
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <img src={control} alt='' />
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <h2>Cruza los filtros de seguridad.</h2>
                            <p>Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles.</p>
                        </div>
                    </div>
                    <div className='proceso-embarque-box'>
                        <div className='proceso-embarque-box-in'>
                            4
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <img src={autobus} alt='' />
                        </div>
                        <div className='proceso-embarque-box-in'>
                            <h2>Haz uso de nuestro autobús para abordar.</h2>
                            <p>Revisa la documentación necesaria para el embarque de adultos mayores, así como servicios de asistencia disponibles.</p>
                        </div>
                    </div>
                </div>
    
            </div>
        </section>
        </>
  )
}
